import React from "react";
import type { OrderActionsProps } from "./types";

export const OrderActions: React.FC<OrderActionsProps> = ({
  side,
  submitLabel = "Submit Order",
  canSubmit,
  submitting,
  onSubmit,
  onCancel,
}) => {
  const submitTone =
    side === "BUY"
      ? "bg-success text-black shadow-[0_0_18px_rgba(0,255,102,0.36)] hover:bg-success/90 active:bg-success/80"
      : "bg-danger text-black shadow-[0_0_18px_rgba(255,43,43,0.36)] hover:bg-danger/90 active:bg-danger/80";

  return (
    <div className="flex gap-3 pt-2">
      <button
        type="button"
        onClick={onCancel}
        disabled={submitting}
        className="min-h-[58px] flex-1 rounded-xl border border-border bg-background-raised px-4 font-display text-[18px] font-bold uppercase text-foreground transition-colors hover:bg-white/10 active:bg-white/15 disabled:opacity-50"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSubmit}
        disabled={!canSubmit}
        className={`min-h-[58px] flex-[1.45] rounded-xl px-4 font-display text-[18px] font-bold uppercase transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${submitTone}`}
      >
        {submitting ? "Submitting..." : submitLabel}
      </button>
    </div>
  );
};
